import React, { useRef } from 'react'
// import { GiPadlock } from 'react-icons/gi'
import logo from '../../logo.png'

export default function EmailConfirmation() {
    const emailRef = useRef()
    const send = () => {

    }
  return (
   <div className='flex flex-row'>
  

      <div className="cta hidden lg:flex lg:flex-col bg-green-500 h-full w-1/2 text-white py-[17.5em] text-center">
        <p className='font-[Satoshi] text-2xl '>Welcome back to RentHub</p>
        <p className='font-[Lexend] '>Continue your journey with us, we make life easier</p>
      </div>

      <div className="form w-full lg:w-1/2">
             <div className='lg:pt-[7em] pt-[1em]'>
           
                     <img className='h-[7em] w-[7em] object-cover  mx-auto' src={logo} alt=''></img>

             <p className="font-[Satoshi] text-2xl font-semibold text-center mb-[1em] ">Confirm Email</p>
          </div>
         
               <div className="email_input ml-[1em] flex flex-col lg:ml-[4em] mb-[1em]">
                  <label class="font-[Lexend]  lg:mb-[1em] text-[1em] font-semibold" for="password">Email</label> 
            
                 <input ref={emailRef} class="w-[90%] lg:w-[80%]  mt-[.5em] mb-[.5em] h-8 border font-[Lexend] p-4 rounded-sm font-normal"   type="text" name="email" placeholder='Enter your email'/>
        </div>
      
                      <button  onClick={send} class="bg-green-500  w-[90%] lg:w-[80%] mb-[1em] ml-[1em] lg:ml-[4em] text-white font-[Lexend] p-2 rounded-lg" name="login" type="button">Submit Email</button>

      </div>
      </div>
  )
}
